import React, { useEffect } from "react";
import ArticulationSideView from "./ArticulationSideView";

export default function ArticulationModal({ open, onClose, target }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90]">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="absolute left-1/2 top-1/2 w-[min(96vw,980px)] -translate-x-1/2 -translate-y-1/2">
        <div className="rounded-2xl border bg-white shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-sm font-semibold text-slate-900">
              Articulation (large)
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border bg-white px-3 py-2 text-xs font-semibold text-slate-800 hover:bg-slate-50"
            >
              Close
            </button>
          </div>

          <div className="p-4">
            <ArticulationSideView
              target={target}
              size="large"
              enableModalClick={false}
              onOpenModal={null}
              label="Articulation"
            />
          </div>
        </div>
      </div>
    </div>
  );
}